import angular from 'angular';
import { forEach } from 'lodash';
import sanitizeS3Key from 'common/helpers/sanitize-s3-key';

module.exports = angular.module('common.directives.photos', [
  require('ng-file-upload'),
  require('angular-carousel'),
  require('angular-sortable-view'),
])
.directive('ocPhotos', function(Upload, S3, Photo, $sce) {
  return {
    restrict: 'ACE',
    scope: {
      ngModel: '=',
      picableType: '@',
      picableId: '=',
      kind: '@?',
      live: '=',
      notWritable: '=',
      preventDelete: '=',
      downloadable: '<?',
      photos: '=ngModel',
      isVendor: '<?',
    },
    controller: function ($scope) {
      $scope.carouselIndex = 0;

      $scope.files = { list: [] };

      $scope.downloadResource = downloadResource;

      function forceDownload(blob, filename) {
        var anchor = document.createElement('a');
        anchor.download = filename;
        anchor.href = blob;
        // For Firefox https://stackoverflow.com/a/32226068
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();
      }

      // Current blob size limit is around 500MB for browsers
      function downloadResource(url, filename) {
        if (!filename) filename = url.split('\\').pop().split('/').pop().split('?').shift();

        window.fetch(url, {
            headers: new Headers({
              'Origin': location.origin
            }),
            mode: 'cors',
            cache: 'no-store'
          })
          .then(response => response.blob())
          .then(blob => {
            let blobUrl = window.URL.createObjectURL(blob);
            forceDownload(blobUrl, filename);
          })
          .catch(e => console.error(e));
      }
    },
    templateUrl: '/templates/common/directives/photos.html',
    require: 'ngModel',
    link: function(scope, element, attrs, ngModelController) {

      scope.$watch('files.list', function(files) {
        var startingPhotoCount = scope.ngModel.length;
        forEach(files, (file, index) => {process(file, startingPhotoCount + index);});
      });

      scope.$watch('photos', function() {
        // reset the index when the entire collection of photos changes
        scope.carouselIndex = 0;
      });

      function process(file, position) {
        if (!file) {
          return null;
        }
        
        if (!file.type.includes('image')) {
          window.alert(
            `Uploaded file ${file.name} has type ${file.type}, which is not an image.`
          );
          return null;
        }
        let sanitizedFileName = sanitizeS3Key(file.name);
        var key = [
          'uploads',
          'photos',
          scope.picableType,
          scope.picableId,
          Date.now() + '-' + sanitizedFileName,
        ].join('/');
        var newPhoto = new Photo({
          picable_type: scope.picableType,
          picable_id: scope.picableId,
          process: 0,
          key: key,
          kind: scope.kind,
          position: position,
        });
        ngModelController.$setValidity(key, false);
        scope.ngModel.push(newPhoto);

        Upload.upload({
          url: S3.rootUrl,
          method: 'POST',
          file: file,
          fields : {
            key: newPhoto.key,
            AWSAccessKeyId: S3.AWSAccessKeyId,
            acl: 'public-read',
            policy: S3.publicReadPolicy,
            signature: S3.publicReadSignature,
            'Content-Type': file.type || 'application/octet-stream'
          }
        }).progress(function(progress) {
          newPhoto.progress = Math.floor(progress.loaded / progress.total * 100);
        }).success(function() {
          if (scope.live) {
            newPhoto.$save().then(function() {
              ngModelController.$setValidity(key, true);
              newPhoto.photo_url = newPhoto.photo_url || S3.rootUrl + key;
            });
          } else {
            newPhoto.photo_url = newPhoto.photo_url || S3.rootUrl + key;
            newPhoto.uploadComplete = true;
            ngModelController.$setValidity(key, true);
          }
        });
      }

      scope.deletedPhotosPresent = false;

      scope.reorder = function(image, toPosition) {
        if (!scope.live) return;
        var workingImage = image;
        if (!image.$reorder) workingImage = new Photo(image);

        workingImage.move_to_position = toPosition;

        workingImage.$reorder().then(function() {
          image.position = toPosition;
        });
      };

      scope.destroy = function(image) {
        if (scope.preventDelete) return;
        if (!scope.live) {
          if (image.id) {
            image._destroy = '1';
          } else {
            var idx = scope.ngModel.indexOf(image);
            scope.ngModel.splice(idx, 1);
          }
        } else {
          var workingImage = image;
          if (!image.$delete) workingImage = new Photo(image);

          workingImage.$delete().then(function() {
            var idx = scope.ngModel.indexOf(image);
            if (idx > -1) scope.ngModel.splice(idx, 1);
          });
        }
      };

      scope.areDeletedPhotosPresent = function() {
        return scope.ngModel.find( lp => lp._destroy === '1' );
      };

      scope.deleteAll = function() {
        scope.ngModel.forEach( lp => lp._destroy = '1' );
        scope.deletedPhotosPresent = scope.areDeletedPhotosPresent();
      };

      scope.unDeleteAll = function() {
        scope.ngModel.forEach( lp => delete lp['_destroy'] );
        scope.deletedPhotosPresent = scope.areDeletedPhotosPresent();
      };

      scope.downloadLink = $sce.trustAsResourceUrl(
        `/${scope.isVendor ? 'vendor' : 'admin'}/photos/download_zip?picable_type=${scope.picableType}&picable_id=${scope.picableId}` //eslint-disable-line max-len
      );
    }
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/directives/photos.js
 **/